import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import "react-multi-date-picker/styles/colors/teal.css";

interface JalaliDateRangePickerProps {
  fromDate: string;
  untilDate: string;
  onChange: (fromDate: string, untilDate: string) => void;
  disabled?: boolean;
  label?: string;
}

const toDateObject = (isoDate: string): DateObject | undefined => {
  if (!isoDate) return undefined;
  const [year, month, day] = isoDate.split("-").map(Number);
  if (!year || !month || !day) return undefined;

  return new DateObject({
    year,
    month,
    day,
  }).convert(persian, persian_fa);
};

const toIsoDate = (value?: DateObject | null): string => {
  if (!value) return "";
  const g = new DateObject(value).convert(gregorian);
  const year = g.year;
  const month = String(g.month.number).padStart(2, "0");
  const day = String(g.day).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default function JalaliDateRangePicker({
  fromDate,
  untilDate,
  onChange,
  disabled = false,
  label = "بازه زمانی",
}: JalaliDateRangePickerProps) {
  const value = [toDateObject(fromDate), toDateObject(untilDate)].filter(
    Boolean
  ) as DateObject[];

  const handleChange = (dates: DateObject | DateObject[] | null) => {
    if (!dates || !Array.isArray(dates)) {
      onChange("", "");
      return;
    }

    const [start, end] = dates;
    onChange(toIsoDate(start), toIsoDate(end));
  };

  return (
    <label className="flex min-w-[280px] flex-col gap-1.5 text-right">
      <span className="text-sm text-gray-600">{label}</span>
      <DatePicker
        range
        rangeHover
        value={value}
        onChange={handleChange}
        calendar={persian}
        locale={persian_fa}
        disabled={disabled}
        format="YYYY/MM/DD"
        calendarPosition="bottom-right"
        containerClassName="w-full"
        inputClass="box-border h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-800 outline-none transition-colors focus:border-primaryVar-500 disabled:cursor-not-allowed disabled:bg-gray-100"
        placeholder="از تاریخ — تا تاریخ"
        editable={false}
        hideOnScroll
        className="teal"
      />
    </label>
  );
}
